import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that dynamically updates the theme-color meta tag based on the current route.
 * 
 * - Public pages (/, /pricing, /contact, etc.) → White (#ffffff) to match PublicHeader
 * - App pages (/app/*) → Dark slate (#020617) to match Sidebar dark background
 * 
 * This creates visual consistency between the mobile status bar and the navigation bar.
 */
const ThemeColor: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Find or create the theme-color meta tag
    let themeColorMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
    
    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta');
      themeColorMeta.name = 'theme-color';
      document.head.appendChild(themeColorMeta);
    }

    // Determine theme color based on route
    const isAppRoute = pathname.startsWith('/app');
    
    if (isAppRoute) {
      // App pages: dark slate-900 to match sidebar gradient (#0f172a)
      // Uses slate-900 (from/via) as it's the dominant color in the gradient
      themeColorMeta.content = '#0f172a';
    } else {
      // Public pages: white to match PublicHeader (#ffffff)
      themeColorMeta.content = '#ffffff';
    }
  }, [pathname]);

  return null;
};

export default ThemeColor;
